import {
  type GroupCellRendererParams,
  type ICellRendererParams,
  type ISetFilterCellRendererParams,
} from '@ag-grid-community/core'

export type RendererParams<TData = any, TValue = any, TContext = any> =
  | ICellRendererParams<TData, TValue, TContext>
  | GroupCellRendererParams<TData, TValue>
  | ISetFilterCellRendererParams<TData, TContext>

export function isFilterCellRenderer<TData = any, TValue = any, TContext = any>(
  params: RendererParams<TData, TValue, TContext>,
): params is ISetFilterCellRendererParams<TData, TContext> {
  // @ts-ignore
  return !!params.isFilterRenderer
}

export function isGroupCellRenderer<TData = any, TValue = any, TContext = any>(
  params: RendererParams<TData, TValue, TContext>,
): params is GroupCellRendererParams<TData, TValue> {
  return !!params?.colDef?.showRowGroup
}

export function isGroupRow(params: RendererParams) {
  // @ts-ignore
  return params.node?.group
}
